import React, { Suspense } from 'react';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';

import { store } from '@/store';
import { StoreProvider } from '@/store/core';
import { NavigationRouter } from '@/components/navigation/NavigationRouter';
import { Loader, Toaster } from '@/ui-kit';
import { reactPlugin } from '@/services/application-insights';
import { TelemetryUserSync } from '@/auth/components';
import ErrorPage from './pages/error/ErrorPage';

const App: React.FC = () => {
  return (
    <AppInsightsErrorBoundary onError={ErrorPage} appInsights={reactPlugin}>
      <StoreProvider store={store} loading={<Loader />}>
        {/* Inside the store so it mounts after rehydration and sees the persisted token. */}
        <TelemetryUserSync />
        <Suspense fallback={<Loader />}>
          <NavigationRouter />
          <Toaster />
        </Suspense>
      </StoreProvider>
    </AppInsightsErrorBoundary>
  );
};

export default App;
